"use client";

import { useEffect } from "react";
import type { MovieSearchParams } from "src/components/film/program/ShowsForDate";
import { useFilminfo } from "src/lib/client/useFilminfo";
import { useProgramDatesContext } from "src/lib/contexts/ContextTypes";
import { SHOWDATES_BY_ID_QUERY, SHOWDATES_BY_TITLE_QUERY } from "src/lib/program/programQueries";
import { useProgramLocationParams } from "src/lib/program/useProgramLocationParams";

//#region [Props]
type ShowDatesLoaderProps = {
  /** the movie to find the dates with shows for: by id, or by title for movies without an id yet */
  movieParams: MovieSearchParams;
  isAdFree?: boolean;
  adFreeSkin?: string | null;
};
//#endregion

//#region [Component]
/**
 * Fetches the dates with shows into the dates context, for the date row, the date dialog and NoShows.
 * Renders nothing. Reads the url (?firm=), so put it in <Suspense fallback={null}>.
 */
export default function ShowDatesLoader({
  movieParams,
  isAdFree,
  adFreeSkin
}: ShowDatesLoaderProps) {
  const {
    setAvailableDates
  } = useProgramDatesContext();
  const {
    locationParams,
    atLeastOneLocationSelected
  } = useProgramLocationParams(isAdFree, adFreeSkin);
  const {
    fiData
  } = useFilminfo(movieParams.movieTitle ? SHOWDATES_BY_TITLE_QUERY : SHOWDATES_BY_ID_QUERY, {
    ...locationParams,
    ...movieParams
  }, {
    active: atLeastOneLocationSelected
  });
  useEffect(() => {
    if (fiData?.showQuery?.getShowDates) {
      const listAsDates = fiData.showQuery.getShowDates.map(d => new Date(d!.date!));
      setAvailableDates(listAsDates);
    } else {
      setAvailableDates(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fiData]);
  return null;
}
//#endregion